export default __webpack_public_path__ + "static/media/Avatar-8.b922bd00.svg";